import React from "react";
import { IoArrowForwardSharp } from "react-icons/io5";
import { Link } from "react-router-dom";

const SpecialServices = () => {
  return (
    <>
      <section className="services-section">
        <div className="container">
          <div className="_2-column-block-top">
            <div
              className="contents max-345px"
              style={{
                opacity: 1,
                transform:
                  "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
              }}
            >
              <div className="margin-bottom-10px">
                <div
                  className="fancy-title-20px"
                  style={{
                    opacity: 1,
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                >
                  Special Services
                </div>
              </div>
              <h2
                className="title-heading"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
              >
                Turning <span className="font-color-primary">Dreams </span>Into
                Destinations
              </h2>
              <p className="margin-top-32px-bottom-37px">
                We have been operating for over a decade, providing top-notch
                services to our clients
              </p>
              <Link
                to="/services"
                data-w-id="ba2560af-a813-130c-b209-b41d37b4cd90"
                className="secondary-button w-inline-block"
              >
                <div className="button-text-wrapper">
                  <div className="default-text">More Services</div>
                  <div className="hover-text">More Services</div>
                </div>
                <div className="button-icon">
                  <IoArrowForwardSharp />
                </div>

                <div
                  className="button-hover-reverse"
                  style={{ width: "100%" }}
                ></div>
              </Link>
            </div>
            <div
              data-w-id="4d487487-8f64-54d0-7882-afd86b128cce"
              style={{
                opacity: 1,
                transform:
                  "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
              }}
              className="service-list-wrapper w-dyn-list"
            >
              <div role="list" className="vertical-left-top-20px w-dyn-items">
                <div role="listitem" className="full-width w-dyn-item">
                  <div
                    data-w-id="24b5509f-4e81-1690-55e4-61f5ae61a3f4"
                    className="service-list-card"
                  >
                    <div
                      className="_24px-text-600"
                      style={{ color: "rgb(25, 27, 26)" }}
                    >
                      Concierge Service
                    </div>
                    <p
                      className="service-summery"
                      style={{ color: "rgb(91, 91, 91)" }}
                    >
                      We have be operating for over a de providing top-notch
                      services to our clients and building
                    </p>
                    <Link
                      to="/services"
                      style={{
                        transform:
                          "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                        transformStyle: "preserve-3d",
                      }}
                      className="arrow-link w-inline-block"
                    >
                      <IoArrowForwardSharp />
                    </Link>
                    <div
                      style={{ width: "0%", height: "150px" }}
                      className="hover-color"
                    ></div>
                  </div>
                </div>
                <div role="listitem" className="full-width w-dyn-item">
                  <div
                    data-w-id="24b5509f-4e81-1690-55e4-61f5ae61a3f4"
                    className="service-list-card"
                  >
                    <div
                      className="_24px-text-600"
                      style={{ color: "rgb(25, 27, 26)" }}
                    >
                      Guided City Tours
                    </div>
                    <p
                      className="service-summery"
                      style={{ color: "rgb(91, 91, 91)" }}
                    >
                      Indulge in the finest luxury travel experiences. From
                      five-star accommodations to exclusive
                    </p>
                    <Link
                      to="/services"
                      style={{
                        transform:
                          "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                        transformStyle: "preserve-3d",
                      }}
                      className="arrow-link w-inline-block"
                    >
                      <IoArrowForwardSharp />
                    </Link>
                    <div
                      style={{ width: "0%", height: "150px" }}
                      className="hover-color"
                    ></div>
                  </div>
                </div>
                <div role="listitem" className="full-width w-dyn-item">
                  <div
                    data-w-id="24b5509f-4e81-1690-55e4-61f5ae61a3f4"
                    className="service-list-card"
                  >
                    <div
                      className="_24px-text-600"
                      style={{ color: "rgb(25, 27, 26)" }}
                    >
                      Resort Packages
                    </div>
                    <p
                      className="service-summery"
                      style={{ color: "rgb(91, 91, 91)" }}
                    >
                      Join our expert-led guided tours for an immersive travel
                      experience Our knowledgeable guides
                    </p>
                    <Link
                      to="/services"
                      style={{
                        transform:
                          "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                        transformStyle: "preserve-3d",
                      }}
                      className="arrow-link w-inline-block"
                    >
                      <IoArrowForwardSharp />
                    </Link>
                    <div
                      style={{ width: "0%", height: "170px" }}
                      className="hover-color"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SpecialServices;
